import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { ProductService } from '../../services/product.service';

/**
 * Component for downloading selected products.
 */
@Component({
  selector: 'mass-download',
  templateUrl: './mass-download.component.html',
  styleUrl: './mass-download.component.css'
})
export class MassDownloadComponent implements OnInit {
	@Input() productGroup: any;
	
	LOCALIZATION: any;
	input = { 
		name: '',
		type: 'PRODUCT',
		metadataType: '',
		flattenOutput: false
	};
	inprogress: boolean = false;
	
	showMetadataType = false;
	showFlattenOutput = true;
	
	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private productService: ProductService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		
		console.log('productGroup:', this.productGroup);
	}
	
	setFormBasedOnType(type: string): void {
		if (type == 'METADATA' || type == 'PRODUCT_AND_METADATA' || type == 'PRODUCT_AND_METADATA_INCLUDE_PDF') {
			this.showMetadataType = true;
		} else {
			this.showMetadataType = false;
		}

		if (type == 'METADATA' || type == 'PRODUCT') {
			this.showFlattenOutput = true;
		} else {
			this.showFlattenOutput = false;
		    this.input.flattenOutput = false;
		}
	}	
	
	setFormBasedOnMetadataType(metadataType: string): void {
		if (metadataType != 'METADATA_CSV') {
			this.showFlattenOutput = true;
		} else {
			this.showFlattenOutput = false;
		    this.input.flattenOutput = false;
		}		
	}	
	
	/**
	 * Downloads the chosen results.
	 */
	download(): void {
		if (!this.input.type || !this.input.name) {
		    this.alertsService.error({
		        message: this.LOCALIZATION.fillAllFields
		    });
		    return;
		}

		this.inprogress = true;
		
		var params = {
		    type: this.input.type,
		    metadataType: this.input.metadataType,
		    requestName: this.input.name,
		    flatten: this.input.flattenOutput
		};
		this.productService.downloadProducts(this.productGroup.ids, params).then(
			(response: boolean) => {
			    this.alertsService.success({
			        title: this.LOCALIZATION.downloadStarted,
			        message: this.LOCALIZATION.processingWaitMessage,
			        delay: 5000
			    });
			    this.close();
			},
			(err: any) => {
				console.error("Failed to download results:", err);
			    this.alertsService.error({
			        message: this.LOCALIZATION.downloadError
			    });
			    this.inprogress = false;
			}
		);		
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
